import React, { useState, useEffect } from 'react';
import FileUpload from './FileUpload';
import { uploadFile } from '../services/s3Service';
import './Form.css';


interface FormData {
    id: string;
    firstName: string;
    lastName: string;
    group: string;
    title: string;
    
    fileName: string;
}

const Form: React.FC = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [group, setGroup] = useState('');
    const [title, setTitle] = useState('');
    // const [content, setContent] = useState(''); // State for rich text editor content
    const [file, setFile] = useState<File | null>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const [submittedData, setSubmittedData] = useState<FormData[]>([]);
    const [activeTab, setActiveTab] = useState('all');
    const [resetFileInput, setResetFileInput] = useState(false); // State to reset file input

    useEffect(() => {
        fetchSubmittedData();
    }, []);

    const fetchSubmittedData = async () => {
        try {
            const response = await fetch('https://xjhnvunknvsddtzvnliupcmeni0cmtlt.lambda-url.us-east-1.on.aws/');
            const data = await response.json();
            setSubmittedData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const resetForm = () => {
        setFirstName('');
        setLastName('');
        setGroup('');
        setTitle('');
        setFile(null);
        setResetFileInput(true); // Trigger file input reset
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const newErrors: string[] = [];

        if (!firstName) newErrors.push('First name is a required field.');
        if (!lastName) newErrors.push('Last name is a required field.');
        if (!group) newErrors.push('SSSE Group is a required field.');
        if (!title) newErrors.push('Title is a required field.');
        // if (!content) newErrors.push('Content is a required field.');
        
        if (!file) newErrors.push('File upload is required.');

        if (newErrors.length > 0) {
            setErrors(newErrors);
        } else {
            setErrors([]);
            try {
                if (file) {
                    await uploadFile(file);
                    console.log('File uploaded successfully');
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                setErrors(['Error uploading file. Please try again.']);
                return;
            }

            try {
                const response = await fetch('https://vttcamy3z2brwou3sl7vskyn5u0jtiyj.lambda-url.us-east-1.on.aws/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        firstName,
                        lastName,
                        group,
                        title,
                        // content,
                       
                        fileName: file ? file.name : ''
                    })
                });

                if (response.ok) {
                    console.log('Form data saved successfully');
                    fetchSubmittedData();
                    // alert('Form submitted successfully!');
                    // resetForm();
                } else {
                    console.error('Error saving form data');
                    setErrors(['Error saving form data. Please try again.']);
                }
            } catch (error) {
                console.error('Error saving form data:', error);
                setErrors(['Error saving form data. Please try again.']);
            }

            setFirstName('');
            setLastName('');
            setGroup('');
            setTitle('');
            // setContent('');
            
            setFile(null);
            setResetFileInput(true);
        }
    };
   
    const handleTabClick = (group: string) => {
        setActiveTab(group);
    };

    const filteredData = activeTab === 'all' ? submittedData : submittedData.filter(data => data.group === activeTab);

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit}>
                {errors.length > 0 && (
                    <div style={{ color: 'red', marginBottom: '10px' }}>
                        {errors.map((error, index) => (
                            <div key={index}>{error}</div>
                        ))}
                    </div>
                )}
                <div>
                    <label>
                        <span style={{ color: 'red' }}>*</span> Student's First Name:
                        <input
                            type="text"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                            maxLength={30}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        <span style={{ color: 'red' }}>*</span> Student's Last Name:
                        <input
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                            maxLength={30}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        <span style={{ color: 'red' }}>*</span> SSSE Group:
                        <select
                            value={group}
                            onChange={(e) => setGroup(e.target.value)}
                            required
                        >
                            <option value="" disabled>Select a group</option>
                            <option value="0">pre-SSSE</option>
                            <option value="1">Group 1</option>
                            <option value="2">Group 2</option>
                            <option value="3">Group 3</option>
                            <option value="4">Group 4</option>
                        </select>
                    </label>
                </div>
                <div>
                    <label>
                        <span style={{ color: 'red' }}>*</span> Title of the Article:
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                            maxLength={60}
                        />
                    </label>
                </div>
                <div>
                <label>
                        <span style={{ color: 'red' }}>*</span> Content:
                        
                    </label>
                </div>
                <FileUpload onFileChange={(file) => setFile(file)} reset={resetFileInput}/>
                <button type="submit">Submit</button>
            </form>

            <div className="tabs">
                <div className={`tab ${activeTab === 'all' ? 'active' : ''}`} onClick={() => handleTabClick('all')}>All Submissions</div>
                <div className={`tab ${activeTab === '0' ? 'active' : ''}`} onClick={() => handleTabClick('0')}>pre-SSSE</div>
                <div className={`tab ${activeTab === '1' ? 'active' : ''}`} onClick={() => handleTabClick('1')}>Group 1</div>
                <div className={`tab ${activeTab === '2' ? 'active' : ''}`} onClick={() => handleTabClick('2')}>Group 2</div>
                <div className={`tab ${activeTab === '3' ? 'active' : ''}`} onClick={() => handleTabClick('3')}>Group 3</div>
                <div className={`tab ${activeTab === '4' ? 'active' : ''}`} onClick={() => handleTabClick('4')}>Group 4</div>
            </div>

            {filteredData.length > 0 && (
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>SSSE Group</th>
                                <th>Title of the Article</th>
                            
                                <th>File Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((data, index) => (
                                <tr key={index}>
                                    <td>{data.firstName}</td>
                                    <td>{data.lastName}</td>
                                    <td>
                                        {data.group === '0' && 'Pre-SSSE'}
                                        {data.group === '1' && 'Group 1'}
                                        {data.group === '2' && 'Group 2'}
                                        {data.group === '3' && 'Group 3'}
                                        {data.group === '4' && 'Group 4'}
                                    </td>
                                    <td>{data.title}</td>
                                    
                                    <td>{data.fileName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Form;